// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"309":"d7c3ddc6","543":"d7c3ddc6","793":"d7c3ddc6","924":"d7c3ddc6","963":"d7c3ddc6"}[chunkId] + ".chunk.css";
};